import React from 'react';
import './App.css';
import EditorPage from "./Pages/Editor/EditorPage";

function App() {
  return (
    <div className="App">
      <EditorPage></EditorPage>
    </div>
  );
}

export default App;
